<template>
    <div>
        <PageHeader :title="pageHeader">
            <template v-slot:icon>
                <svg xmlns="http://www.w3.org/2000/svg" class="page-header-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                </svg>
            </template>
        </PageHeader>
        
        <div class="p-2 pb-4 bg-white rounded-md" v-if="!loadingEntireScreen">
            <div class="flex justify-center items-center mb-4">
                <img class="w-52" src="../assets/logo-megaluzz.png" alt="Megaluzz Logo">
            </div>

            <div class="flex w-full justify-center">
                <div class="relative w-8/12">
                    <!-- Ícone dentro do input -->
                    <span class="absolute inset-y-0 left-3 flex items-center text-gray-500">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                            stroke="currentColor" stroke-width="1.5">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
                        </svg>
                    </span>

                    <!-- Input com padding-left para não sobrepor o ícone -->
                    <input
                        placeholder="Pesquisar por nome do cliente..."
                        class="w-full pl-10 uppercase pr-4 text-center p-2 bg-white border border-gray-300 font-bold text-gray-500 text-base rounded-md focus:outline-none focus:ring focus:ring-opacity-25 focus:ring-green-400 disabled:bg-gray-100"
                        v-model="filter.name"
                        @keyup.enter="loadData"
                    />
                </div>
            </div>
        </div>
        
        <Alert text="Ainda não existem clientes cadastrados" :show="!companies.length && !loading" />

        <div class="table-container" v-if="companies.length && !loadingEntireScreen">
            <BaseButton :to="{ name: 'company', params: {} }" skin="primary-small" class="mb-4">
                <template v-slot:icon>
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                    </svg>
                </template>
                Adicionar
            </BaseButton>


            <table class="w-full" v-if="!loading">
                <thead>
                    <tr>
                        <th class="text-center">#</th>
                        <th>NOME/DOC</th>
                        <th>Email</th>
                        <th>WHATSAPP</th>
                        <th>UF/CIDADE</th>
                        <th v-if="authInfo.has_delete"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="table-row" v-for="(company, index) in companies" :key="company.id">
                        <td>
                            <div class="flex gap-x-2 justify-center items-center">
                                <div class="text-base font-black text-green-500">#{{ index + 1 }}</div>
                                <BaseButton skin="primary-outline" :to="{ name: 'company', params: { id: company.id } }">Gerenciar</BaseButton>
                            </div>
                        </td>
                        <td style="width: 30%;">
                            <div class="flex flex-col">
                                <div class="flex gap-x-2">
                                    <span class="text-sm font-bold text-green-700 uppercase break-words whitespace-normal" :title="company.name">{{ company.name }}</span>
                                    <a v-if="company.file_url" class="hover:bg-green-200 float-left w-6 rounded-full" target="_blank" :href="company.file_url">
                                        <svg xmlns="http://www.w3.org/2000/svg" v-if="company.file_url" class="h-6 w-6 rounded-full text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13" />
                                        </svg>
                                    </a>
                                </div>
                                <span class="text-xs font-bold text-gray-500">{{ company.cnpj || company.cpf }}</span>
                            </div>
                        </td>
                        <td style="width: 20%">
                            <div class="flex flex-col">
                                <span class="text-xs text-green-700 break-all whitespace-normal border-green-200">{{ company.email }}</span>
                                <span class="text-xs text-green-700 break-all whitespace-normal mt-2">{{ company.email2 }}</span>
                            </div>
                        </td>
                        <td style="width: 300px;">
                            <span class="text-sm leading-5 text-green-700 break-all whitespace-normal">{{ company.whatsapp || '-' }}</span>
                        </td>
                        <td>
                            <div class="flex flex-col">
                                <span class="text-sm leading-5 text-green-700 uppercase font-semibold">{{ company.state.name }}</span>
                                <span class="text-sm leading-5 text-green-700">{{ company.city.name }}</span>
                            </div>
                        </td>
                        <td v-if="authInfo.has_delete">
                            <svg @click="deleteCompany(company.id)" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 text-red-400">
                                <path stroke-linecap="round" stroke-linejoin="round" d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0" />
                            </svg>
                        </td>
                    </tr>
                </tbody>
            </table>
            <Pagination :total="totalItens" :limit="limit" @changePage="changePagination" />
        </div>

        <div class="flex justify-center pb-4">
            <Loading :show="loading" text="Carregando dados, aguarde..." />
        </div>
    </div>
</template>

<script>

import { ref } from 'vue';
import { CompanyService } from '../services/Entity';
import Alert from '@/components/Alert';
import Pagination from '@/components/Pagination';
import Swal from 'sweetalert';
import { defaultDate } from '../filters/date';
import AuthService from '../services/AuthService';

export default {
    components: {
        Pagination,
        Alert
    },
    setup() {
        const pageHeader = ref('Clientes');
        const filter = ref({});
        const page = ref(1);
        const limit = ref(50);
        const totalItens = ref(0);
        const loading = ref(false);
        const loadingEntireScreen = ref(false);
        const companies = ref([]);
        const authInfo = AuthService.getAuthInfo();

        async function init() {
            loadingEntireScreen.value = true;
            await loadData()
            loadingEntireScreen.value = false;
        }

        async function loadData() {
            loading.value = true;
            await loadCompanies(filter.value);
            loading.value = false;
        }

        async function loadCompanies(filter) {
            try {
                const listingFilter = { page: 1, limit: 9999 };
                const { data: { total, items } } = await CompanyService.list(listingFilter.page, listingFilter.limit, filter);

                companies.value = items;
                totalItens.value = total;
            } catch(err) {
                loading.value = false;
                console.log(err);
                Swal({
                    title: 'Ocorreu um erro ao obter dados dos clientes',
                    text: 'Atualize a página e tente novamente',
                    icon: 'error'
                });
            }
        }

        async function changePagination(currentPage) {
            page.value = currentPage;
            loading.value = true;
            await loadCompanies(page.value, limit.value, filter.value);
            loading.value = false;
        }

        async function deleteCompany(companyId) {
            Swal({
                title: 'ATENÇÃO! Deseja mesmo excluir uma EMPRESA?',
                text: 'Será excluido juntamente com a empresa, todos os seus registros, reuniões, pedidos, usuários, arquivos e etc.',
                icon: 'warning',
                buttons: {
                    cancel: 'Cancelar',
                    confirm: {
                        text: 'Excluir Agora',
                        className: 'swal-button--danger'
                    }
                },
                dangerMode: true
            }).then(async (confirm) => {
                if (confirm) {
                    loading.value = true;
                    const { data: { data } } = await CompanyService.destroy(companyId);
                    await loadData();


                    Swal({
                        title: `Excluida`,
                        icon: 'success',
                    });
                }
            });
        }

        init();

        return {
            deleteCompany,
            authInfo,
            loadData,
            pageHeader,
            companies,
            changePagination,
            loading,
            loadingEntireScreen,
            page,
            limit,
            totalItens,
            filter,
            defaultDate
        }
    },
}
</script>